import React, { useContext, useEffect, useState } from 'react';
import { Grid } from '@nextiva/next-ui-components';

import { COSPACE_PROD, COSPACE_DEV, COSPACE_RC } from 'constants/urls';

import { DispatchChimeContext, actionTypes } from '../context';

import Footer from './footer';

const Step1 = () => {
  const chimeDispatch = useContext(DispatchChimeContext);

  const [copsaceUrl, setCospaceUrl] = useState(COSPACE_PROD);

  useEffect(() => {
    const { origin } = window.location;

    if (origin.includes('dev')) setCospaceUrl(COSPACE_DEV);
    if (origin.includes('rc')) setCospaceUrl(COSPACE_RC);
  });

  const setStep = (step) => {
    chimeDispatch({
      type: actionTypes.SET_CHIME_DRAWER_STEP,
      step,
    });
  };

  const setDrawerStatus = (state) => {
    chimeDispatch({
      type: actionTypes.SET_CHIME_DRAWER_STATUS,
      state,
    });
  };

  const closeHandler = () => {
    setDrawerStatus(false);
  };

  const stepHandler = () => {
    setStep(2);
  };

  return (
    <>
      <div className="m-chime-drawer__content step1">
        <Grid container spacing={2} className="header">
          <Grid item xs={12}>
            <span className="cospace-logo" />
          </Grid>
          <Grid item xs={12} className="description">
            <span className="Heading5"></span>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <div className="m-chime-drawer__message">
            Cospace is native to NextOS and is available for all your users to
            use right now.
          </div>
          <a href={copsaceUrl} data-testid="PlatformAdminUI-Step1-Launch">
            Launch Cospace
          </a>
        </Grid>
        <span className="spacer" />
        <Grid container spacing={2} className="header">
          <Grid item xs={12}>
            <span className="chime-logo" />
          </Grid>
          <Grid item xs={12} className="description">
            <span className="Heading5">About this Integration.</span>
          </Grid>
          <Grid item xs={12}>
            With Nextiva and Amazon Chime you can make phone calls and host
            online meetings—with voice, video, screen sharing, and chat. All in
            place.
          </Grid>
        </Grid>
      </div>
      <Footer
        cancelOnClick={closeHandler}
        saveText="Next"
        saveOnClick={stepHandler}
      />
    </>
  );
};

export default Step1;
